(function() {
    'use strict';

    angular.module('app.feriados', []);
})();
